// extracted by mini-css-extract-plugin
export default {"div_table":"headered-list_div_table__OaBHW","div_table_row":"headered-list_div_table_row__O2wQ2"};